// extracted by mini-css-extract-plugin
export default {"container":"DisconnectedModulePopup_container__OM8mV","title":"DisconnectedModulePopup_title__JHfvP","buttonContainer":"DisconnectedModulePopup_buttonContainer__ZKixb"};